import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_WORKSPACES, FETCH_WORKSPACE, WORKSPACE_REMOVE, WORKSPACE_SAVE, WORKSPACE_ADD_RULE, WORKSPACE_REMOVE_RULE, WORKSPACE_CREATE, FETCH_ERROR } from './actions.type'
import { SET_WORKSPACES, SET_WORKSPACES_ERRORS, SET_WORKSPACES_LOADING, SET_WORKSPACE, SET_WORKSPACE_ERRORS, SET_WORKSPACE_LOADING, SET_WORKSPACE_ADD_RULE_ERRORS, SET_WORKSPACE_ADD_RULE_LOADING } from './mutations.type'

const state = {
	workspaces: [],
	workspacesErrors: [],
	workspacesIsLoading: false,
	workspace: null,
	workspaceErrors: [],
	workspaceIsLoading: false,
	workspaceAddRuleErrors: [],
	workspaceAddRuleIsLoading: false
}

const getters = {
	workspaces : state => key => {
		return state.workspaces.filter(x => x.name.toLowerCase().includes(key.toLowerCase()))
	},
	workspacesForSelect (state) {
		var workspaces_select = []
		for (var i = 0; i < state.workspaces.length; i++) {
			var workspace = { value: state.workspaces[i].name, text: state.workspaces[i].name }
			workspaces_select.push(workspace)
		}
		return workspaces_select
	},
	workspacesErrors (state) {
		return state.workspacesErrors
	},
	workspacesIsLoading (state) {
		return state.workspacesIsLoading
	},
	workspace (state) {
		return state.workspace
	},
	workspaceErrors (state) {
		return state.workspaceErrors
	},
	workspaceIsLoading (state) {
		return state.workspaceIsLoading
	},
	workspaceAddRuleErrors (state) {
		return state.workspaceAddRuleErrors
	},
	workspaceAddRuleIsLoading (state) {
		return state.workspaceAddRuleIsLoading
	}
}

const actions = {
	[FETCH_WORKSPACES] (context, params) {
		context.commit(SET_WORKSPACES_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/workspaces')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_WORKSPACES, data)
					resolve(data)
				} else {
					context.commit(SET_WORKSPACES_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_WORKSPACES_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_WORKSPACES_LOADING, false)
			})
		})
	},
	[FETCH_WORKSPACE] (context, params) {
		context.commit(SET_WORKSPACE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy('manager/workspaces', params.name)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_WORKSPACE, data)
					resolve(data)
				} else {
					context.commit(SET_WORKSPACE_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_WORKSPACE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_WORKSPACE_LOADING, false)
			})
		})
	},
	[WORKSPACE_CREATE] (context, params) {
		context.commit(SET_WORKSPACE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post('manager/workspaces/', params)
			.then(({data}) => {
				if (data.hasOwnProperty('name')) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Рабочая область создана", title: "Готово" })
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось создать рабочую область" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось создать рабочую область" })
				ErrorsService.setFetchError(SET_WORKSPACE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_WORKSPACE_LOADING, false)
			})
		})
	},
	[WORKSPACE_SAVE] (context, params, ) {
		context.commit(SET_WORKSPACE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/workspaces/`, params)
			.then(({data}) => {
				if (data.hasOwnProperty('nameNew')) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Название рабочей области изменено", title: "Готово" })
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось изменить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось изменить" })
				ErrorsService.setFetchError(SET_WORKSPACE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_WORKSPACE_LOADING, false)
			})
		})
	},
	[WORKSPACE_REMOVE] (context, name) {
		context.commit(SET_WORKSPACE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.delete(`manager/workspaces/${name}`)
			.then(({data}) => {
				if (data) {
					state.workspaces = state.workspaces.filter(x => x.name != name)
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Рабочая область удалена", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				ErrorsService.setFetchError(SET_WORKSPACE_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_WORKSPACE_LOADING, false)
			})
		})
	},

	[WORKSPACE_ADD_RULE] (context, params) {
		context.commit(SET_WORKSPACE_ADD_RULE_LOADING)
		context.commit(SET_WORKSPACE_ADD_RULE_ERRORS)
		return new Promise((resolve, reject) => {
			ApiService.post(`manager/workspaces/${params.workspace}/rules`, params.body)
			.then(({data}) => {
				if (data === true) {
					// В данный момент контроллер присылает true даже если доступ, который нужно добавить, уже существует
					// Уведомление об успехе будет показываться там, где откуда пришел вызов
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось добавить доступ" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось добавить доступ" })
				ErrorsService.setFetchError(SET_WORKSPACE_ADD_RULE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_WORKSPACE_ADD_RULE_LOADING, false)
			})
		})
	},
	[WORKSPACE_REMOVE_RULE] (context, params) {
		context.commit(SET_WORKSPACE_ADD_RULE_LOADING)
		context.commit(SET_WORKSPACE_ADD_RULE_ERRORS)
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/workspaces/${params.workspace}/rules`, params.body)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Доступ удален", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить доступ" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить доступ" })
				ErrorsService.setFetchError(SET_WORKSPACE_ADD_RULE_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_WORKSPACE_ADD_RULE_LOADING, false)
			})
		})
	},
}

const mutations = {
	[SET_WORKSPACES] (state, data) {
		state.workspaces = data
		state.workspacesErrors = []
	},
	[SET_WORKSPACES_ERRORS] (state, errors) {
		state.workspaces = []
		state.workspacesErrors = errors
	},
	[SET_WORKSPACES_LOADING] (state, status = true) {
		state.workspacesIsLoading = status
	},
	[SET_WORKSPACE] (state, data) {
		state.workspace = data
		state.workspaceErrors = []
	},
	[SET_WORKSPACE_ERRORS] (state, errors) {
		state.workspace = null
		state.workspaceErrors = errors
	},
	[SET_WORKSPACE_LOADING] (state, status = true) {
		state.workspaceIsLoading = status
	},

	[SET_WORKSPACE_ADD_RULE_ERRORS] (state, errors) {
		if (errors === undefined) {
			state.workspaceAddRuleErrors = []
		}
		else {
			state.workspaceAddRuleErrors = errors
		}		
	},
	[SET_WORKSPACE_ADD_RULE_LOADING] (state, status = true) {
		state.workspaceAddRuleIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/workspaces.module.js